import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { modeFavicon } from '../../mode-nevek';
import { InventarioService } from '../inventario.service';

/*  KÉSZLETKEZELÉS – kezdőlap: a képernyők csempéi és a cég összesítője (cikkek, készletérték,
 *  minimum alatti cikkek, a hónap mozgásai). */
@Component({
  selector: 'app-inventario-kezdolap',
  templateUrl: './kezdolap.component.html',
  styleUrls: ['../../szamlazo/kezdolap/kezdolap.component.scss'],
})
export class InventarioKezdolapComponent implements OnInit, OnDestroy {
  ikon = modeFavicon('INVENTARIO');
  readonly csempek = [
    { cim: 'Cikkek', leiras: 'Vonalkód, egyedi mezők, tömeges felvétel és szerkesztés, címke, Excel', ikon: 'pricetags-outline', ut: '/inventario/cikkek' },
    { cim: 'Készlet', leiras: 'Raktáranként, átlagáras értékkel, minimum alatti cikkek', ikon: 'cube-outline', ut: '/inventario/keszlet' },
    { cim: 'Mozgások', leiras: 'Bevételezés, kiadás, átvezetés, selejtezés – vonalkód-olvasással', ikon: 'swap-horizontal-outline', ut: '/inventario/mozgasok' },
    { cim: 'Leltár', leiras: 'Készletellenőrzés olvasással, a különbözet könyvelése', ikon: 'barcode-outline', ut: '/inventario/leltar' },
    { cim: 'Beállítások', leiras: 'Raktárak, egyedi mezők, ügyfél-hozzáférés', ikon: 'settings-outline', ut: '/inventario/beallitasok' },
  ];
  ossz: any = null;
  private sub?: Subscription;
  constructor(public inv: InventarioService, private router: Router) {}
  async ngOnInit() { await this.inv.init(); this.sub = this.inv.aktiv$.subscribe(() => this.osszesit()); }
  ngOnDestroy() { this.sub?.unsubscribe(); }
  async osszesit() {
    const u = this.inv.aktiv.ugyfelId;
    if (!u) { this.ossz = null; return; }
    try {
      const r: any = await this.inv.get(`/cikkek/${u}`);
      const k = (r.cikkek || []).filter((c: any) => +c.keszletes);
      const m: any[] = await this.inv.get(`/mozgasok/${u}?tol=${new Date().toISOString().slice(0, 8)}01`);
      this.ossz = { cikk: (r.cikkek || []).length, ertek: k.reduce((n: number, c: any) => n + (c.ertek || 0), 0), hiany: k.filter((c: any) => c.hiany).length, mozgas: m.length };
    } catch { this.ossz = null; }
  }
  nyit(c: any) { this.router.navigateByUrl(c.ut); }
  szam(v: number) { return Number(v || 0).toLocaleString('hu-HU', { maximumFractionDigits: 0 }); }
}
